import config from "../config";

export const getGcpRegistryAppLink = (customerId: string, siteId: string) =>
  `${config.endpoints.gcpRegistryApp}/${customerId}/${siteId}`;
